module.exports = __webpack_public_path__ + "img/Proliferation-LICA_GSE236681.cfd14f52.png";